export default __webpack_public_path__ + "static/media/71.f8e418cc.jpg";